import { Box, CircularProgress } from "@mui/material";

interface LoadingSpinnerProps {
  py?: number;
}

export function LoadingSpinner({ py = 8 }: LoadingSpinnerProps) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py }}>
      <CircularProgress />
    </Box>
  );
}
